import { GridCellPosition as GridCellPosition_internal } from "./GridCellPosition";
var IgrGridCellPosition = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridCellPosition() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridCellPosition.prototype.createImplementation = function () {
        return new GridCellPosition_internal();
    };
    Object.defineProperty(IgrGridCellPosition.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridCellPosition.prototype.onImplementationCreated = function () {
    };
    IgrGridCellPosition.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridCellPosition.prototype, "rowIndex", {
        /**
         * Gets or sets the row position of the cell.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrGridCellPosition.prototype, "columnUniqueKey", {
        /**
         * Gets or sets the column position of the cell.  Can be null for spanning elements like section headers.
        */
        get: function () {
            return this.i.d;
        },
        set: function (v) {
            this.i.d = v;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridCellPosition.prototype.findByName = function (name) {
        return null;
    };
    return IgrGridCellPosition;
}());
export { IgrGridCellPosition };
//# sourceMappingURL=igr-grid-cell-position.js.map
